import { Pipe, PipeTransform } from '@angular/core';

import { jsonataEval } from '@assess/shared/dynamic-components';
import { Nullable } from '@assess/shared/type-utilities';

@Pipe({ name: 'jsonata' })
export class JsonataPipe implements PipeTransform {
  transform(source: any, expression: Nullable<string>, defaultValue?: any) {
    return jsonataEval(expression, source) ?? defaultValue;
  }
}
